import ModalForm from "../../../components/base/forms/modal-form";
import Api from "../../../lib/api";
import ServiceLocator from "../../../global/service-locator";
import {AnalyticsService} from "../../../services/analytics-service";

export default class EventRegistrationForm {
	constructor() {
		this.$root = document.getElementById('modal-event-registration');
		this.$triggers = document.querySelectorAll(
			'[data-modal-trigger="event-registration"]:not([data-mode="over"])');

		this.sl = ServiceLocator.instance;

		this.form = null;
		this.timerId = null;

		if (this.$root && this.$triggers.length) {
			this.init();
		}
	}

	checkPaymentStatus(pid) {
		Api.get(`${Api.restSiteUrl}/1.0/lms/check-event-payment`, {
			payment_id: pid
		}).then((res) => {
			if (!res || res.status !== 'ok') {
				this.form.showScreen('processing');
				clearInterval(this.timerId);
				return;
			}

			if (res.paymentStatus === 'paid') {
				clearInterval(this.timerId);
				this.form.showScreen('success');
			} else if (res.paymentStatus === 'failed') {
				clearInterval(this.timerId);
				this.form.showScreen('failure');
			} else if (res.paymentStatus === 'processing') {
				this.form.showScreen('processing');
			}
		}).catch((error) => {
			this.form.showScreen('processing');
			clearInterval(this.timerId);
		});
	}

	startPaymentCheckInterval(pid) {
		let counter = 0;

		this.checkPaymentStatus(pid);

		this.timerId = setInterval(() => {
			if (counter >= 4) {
				clearInterval(this.timerId);
				this.form.showScreen('processing');
				return;
			}

			counter++;
			this.checkPaymentStatus(pid);
		}, 15000);
	}

	init() {
		if (window.OneSignal) {
			OneSignal.push(["init", {
				appId: craft.page.oneSignalAppId,
				autoRegister: false,
				notifyButton: {
					enable: false
				},
				welcomeNotification: {
					disable: true
				}
			}]);
		}

		const $paidEventFormResultButton = document.getElementById('paidEventFormResultButton');

		if (craft.page.isPaidEvent && $paidEventFormResultButton) {
			$paidEventFormResultButton.addEventListener('click', (e) => {
				e.preventDefault();
				this.form.showScreen('layout');
				this.form.validate();
			});
		}

		this.form = new ModalForm({
			formId: 'event-registration',
			uri: craft.page.isPaidEvent ? '/1.0/blog/event/paid-registration' : '/2.0/blog/event/registration',
			data: {
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
				referrer: location.href,
				city: Api.currentCityId,
				eventId: craft.page.entryId,
				source: 'registration'
			},
			$modalTriggers: Array.from(this.$triggers),
			urlHashes: !craft.page.registrationPaused && craft.page.isPaidEvent ? [
				'registration',
				'registration-status'
			] : null,
			hash: !craft.page.registrationPaused ? 'registration' : null,
			showResult: !craft.page.isPaidEvent,
			beforeOpen: ($trigger, { hash }) => {
				if (hash === 'registration-status') {
					const queryParams = new URLSearchParams(window.location.search);
					const pid = queryParams.get('pid');

					setTimeout(() => {
						this.form.showScreen('loading');

						if (pid) {
							this.startPaymentCheckInterval(pid);
						}
					}, 0);
				}
			},
			afterClose: () => {
				if (this.timerId) {
					clearInterval(this.timerId);
				}

				this.form.showScreen('layout');
			},
			subscriptions: [
				{
					field: 'remind',
					event: 'valueChange',
					callback: ({ detail }) => {
						if (detail === true) {
							this.webPush();
						}
					}
				},
				{
					// Update custom fields data to format { label, value }
					event: 'beforeSubmit',
					callback: ({ detail }) => {
						const updatedData = {};

						for (let key in detail) {
							if ((/^custom-\d+/).test(key)) {
								const field = this.form.getField(key);

								updatedData[key] = {
									label: field.getLabel(),
									value: detail[key]
								};
							}
						}

						if (this.sl.userDataService.lmsUserData) {
							Object.assign(updatedData, { lmsUserId: this.sl.userDataService.lmsUserData._id });
						}

						this.form.addData(updatedData);

						const dataLayerEventData = {
							event: 'register_for_event_form',
							formId: this.form.formId,
							phone: this.form.data.tel,
							email: this.form.data.email
						};

						const $formTitle = this.form.$root.querySelector('.form_title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent('register_for_event_form', dataLayerEventData);
					}
				},
				{
					event: 'submitComplete',
					callback: ({ detail }) => {
						if (detail.data && detail.data.applicationId) {
							costorage.set(`h_eventApplicationId_${craft.page.entryId}`, detail.data.applicationId, { expires: (30 * 24 * 60 * 60), path: '/', domain: '.ithillel.ua' });
							const $translationButtons = document.querySelectorAll('[href^="https://rest.dev.ithillel.ua/cte/"]');

							if ($translationButtons.length) {
								$translationButtons.forEach(($button) => {
									$button.href = `https://rest.dev.ithillel.ua/cte/${detail.data.applicationId}/b`;
								});
							}
						}

						if (!craft.page.isPaidEvent) {
							return;
						}

						if (detail.data && detail.data.url) {
							location.href = detail.data.url;
						} else {
							this.form.showScreen('failure');
						}
					}
				},
				{
					event: 'submitFinish',
					callback: ({ detail }) => {
						if (craft.page.telegramGroupUrl) {
							window.open(craft.page.telegramGroupUrl, '_blank');
						}
					}
				}
			]
		});
	}

	webPush() {
		if (!window.OneSignal) return;

		this.getWebPushSubscriptionState().then((state) => {
			if (state.isPushEnabled) {
				/* Push enabled, update user tag */
			} else {
				if (state.isOptedOut) {
					/* Opted out, opt them back in */
					OneSignal.setSubscription(true);
				} else {
					/* Unsubscribed, subscribe them */
					OneSignal.registerForPushNotifications();
				}
			}
		});

		OneSignal.push(["sendTag", craft.page.oneSignalTag, "y"]);
	}

	getWebPushSubscriptionState() {
		return Promise.all([
			OneSignal.isPushNotificationsEnabled(),
			OneSignal.isOptedOut()
		]).then(function(result) {
			const isPushEnabled = result[0];
			const isOptedOut = result[1];

			return {
				isPushEnabled: isPushEnabled,
				isOptedOut: isOptedOut
			};
		});
	}
}